import { render, staticRenderFns } from "./AuditTrailDetail.vue?vue&type=template&id=4c05d996"
import script from "./AuditTrailDetail.vue?vue&type=script&lang=js"
export * from "./AuditTrailDetail.vue?vue&type=script&lang=js"
import style0 from "./AuditTrailDetail.vue?vue&type=style&index=0&id=4c05d996&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c05d996')) {
      api.createRecord('4c05d996', component.options)
    } else {
      api.reload('4c05d996', component.options)
    }
    module.hot.accept("./AuditTrailDetail.vue?vue&type=template&id=4c05d996", function () {
      api.rerender('4c05d996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audittrail/AuditTrailDetail.vue"
export default component.exports